import React from 'react';
import { Container } from '@material-ui/core';
import { Col, Row } from 'react-bootstrap';
import BookingDetails from '../BookingDetails/BookingDetails';
import BookingForm from '../BookingForm/BookingForm';

const Booking = () => {
    return (
        <div className="mt-3">
            <Container>
                <Row>
                    <Col xs={6}>
                        <BookingDetails />
                    </Col>
                    <Col xs={6}>
                        <BookingForm />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Booking;